import React from 'react';
import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardTitle } from '@/components/ui/card';
interface Treatment {
  name: string;
  href: string;
  description: string;
  price: string;
  memberPrice: string;
}
interface ConditionPageProps {
  title: string;
  subtitle: string;
  description: string;
  treatments: Treatment[];
  heroImage?: string;
  beforeAfterText: string;
}
const ConditionPageTemplate = ({
  title,
  subtitle,
  description,
  treatments,
  beforeAfterText
}: ConditionPageProps) => {
  return <Layout>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-juv-soft-blush to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-juv-deep-chestnut mb-6 font-juv-heading">
              {title}
            </h1>
            <p className="text-xl text-juv-deep-chestnut leading-relaxed font-juv-body mb-8">
              {subtitle}
            </p>
            <p className="text-lg text-juv-deep-chestnut leading-relaxed font-juv-body max-w-3xl mx-auto">
              {description}
            </p>
          </div>
        </div>
      </section>

      {/* Treatments Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-juv-deep-chestnut mb-12 text-center font-juv-heading">
              Treatments That Help
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {treatments.map((treatment, index) => <Card key={index} className="group hover:shadow-glow transition-all duration-300 hover:scale-105 border-juv-rose-clay/20 bg-gradient-to-br from-white to-juv-soft-blush/30 bg-slate-50">
                  <CardContent className="p-6 bg-slate-50">
                    <CardTitle className="text-xl font-semibold text-juv-deep-chestnut mb-3 font-juv-heading">
                      {treatment.name}
                    </CardTitle>
                    <CardDescription className="text-juv-deep-chestnut mb-4 font-juv-body">
                      {treatment.description}
                    </CardDescription>
                    <div className="space-y-2 mb-6">
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-juv-deep-chestnut">Visitor:</span>
                        <span className="font-semibold text-juv-deep-chestnut">{treatment.price}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-juv-deep-chestnut">Member:</span>
                        <span className="font-semibold text-juv-terracotta">{treatment.memberPrice}</span>
                      </div>
                    </div>
                    <Button asChild className="w-full bg-gradient-to-r from-juv-rose-clay to-juv-terracotta text-white hover:shadow-glow">
                      <Link to={treatment.href}>Learn More</Link>
                    </Button>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-16 bg-gradient-to-br from-juv-soft-blush/30 to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-juv-deep-chestnut mb-6 font-juv-heading">
              Real Results
            </h2>
            <p className="text-lg text-juv-deep-chestnut mb-8 font-juv-body">
              {beforeAfterText}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-juv-deep-chestnut hover:bg-juv-terracotta text-white">
                <Link to="/locations">Book Consultation</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-juv-rose-clay text-juv-terracotta hover:bg-juv-rose-clay hover:text-white">
                <Link to="/memberships">Compare Glow Plans</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-juv-terracotta text-juv-terracotta hover:bg-juv-terracotta hover:text-white">
                <Link to="/quiz">Take Glow Quiz</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
};
export default ConditionPageTemplate;